/**
 * The public path the § 312k BGB cancellation page lives at (kitecorp/transferify-ui#2327), in one
 * React-free place so the route table, the `<Seo>` canonical, the nav row and the e2e journey cannot disagree.
 *
 * <p>ONE path for every language, like every other route in this app. The localized-slug mechanism is the
 * markdown content corpus's alone, and a localized path here would buy nothing: the German storefront is the
 * `/de` tree, so `transferify.eu/de/cancel-contract` is already the German page.
 */

/** The statutory confirmation page. Reachable with no session, on every storefront. */
export const CANCEL_CONTRACT_PATH = "/cancel-contract";
